import React from "react";
import { Button } from "react-bootstrap";
import { Breakpoint } from "react-socks";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

function getCenteredModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,

        backgroundColor: "#FFFFFF",
        color: "#000000"
    };
}

const styles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        overflow: "auto",
        height: "75%",
        width: "90%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        borderRadius: 10,
        outline: 0,
        padding: theme.spacing(4, 4, 4),
    }
}));

export default function UpdatesModal() {

    const classes = styles();
    const [modalStyle] = React.useState(getCenteredModalStyle);
    let [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button style={{
                backgroundColor: "#007BFF",
                color: '#000000',
            }} onClick={handleOpen}>
                Walkthrough
            </Button>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <div style={modalStyle} className={classes.paper}>
                    <h2 style={{ textAlign: "center" }}>Terminal Walkthrough</h2>
                    <br />
                    <h5 style={{ color: "#007BFF" }}>
                        What is a terminal?
                    </h5>
                    <li>
                        A user-controlled, direct environment in which commands can be run.
                    </li>
                    <li>
                        Also called a shell or command line.
                    </li>
                    <br />
                    <br />
                    <h5 style={{ color: "#007BFF" }}>
                        Commands
                    </h5>
                    <li>
                        Instructions that a terminal parses.
                    </li>
                    <li>
                        Typically the first word or the first few words in a line that is fed to the terminal.
                    </li>
                    <Breakpoint medium up>
                        <li>
                            Typing the command <span style={{ color: "#007BFF" }}>help</span> followed by enter will output a list of runnable commands
                            on my terminal.
                        </li>
                    </Breakpoint>
                    <Breakpoint small down>
                        <li>
                            Typing the command <span style={{ color: "#007BFF" }}>commands</span> followed by enter will output a list of runnable commands
                            on my terminal.
                        </li>
                    </Breakpoint>
                    <br />
                    <br />
                    <h5 style={{ color: "#007BFF" }}>
                        Flags
                    </h5>
                    <li>
                        Command-specific words or phrases that can be added to a command.
                    </li>
                    <li>
                        Also called tags.
                    </li>
                    <br />
                    <br />
                    <h5 style={{ color: "#007BFF" }}>
                        Example command + flag combinations
                    </h5>
                    <p>
                        <span style={{ color: "#007BFF"}}>Note:</span> Running a command without flags will return a summary of the command and flags it accepts.
                    </p>
                    <p><span style={{ color: "#007BFF"}}>Note:</span> Examples below can be copied/pasted to and from my terminal like normal.</p>
                    <li style={{ color: "#007BFF" }}>
                        whois Aniket
                    </li>
                    <li style={{ color: "#007BFF" }}>
                        reveal Stack
                    </li>
                    <li style={{ color: "#007BFF" }}>
                        parse Indigo
                    </li>
                    <li style={{ color: "#007BFF" }}>
                        open Indigo -repo
                    </li>
                    <div>
                        <Button onClick={handleClose} style={
                            {
                                backgroundColor: "#007BFF",
                                color: "#000000",
                                marginTop: 20,
                            }
                        }>
                            Close
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
